import React, { useContext, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import setImpersonationToLS from '../../../../../common/utility/setImpersonationToLS';

import FilterCtx from '../../../../../context/filterContext/filterCtx';
import { RootState } from '../../../../../redux/store';
import { IMPERSONATE } from '../../../../../redux/types';

import { IGridCell } from '../../../../ui/types/IGridCell';

import Icon from '../../../../ui/icon/icon';
import useForceUpdate from '../../../../../common/hooks/useForceUpdate';

const SelectCell: React.FC<IGridCell> = ({ dataItem }) => {
  const [checked, setChecked] = useState<boolean>(false);

  const dispatch = useDispatch();
  const filterCtx: any = useContext(FilterCtx);

  const impersonate = useSelector((state: RootState) => state.impersonate);

  const clickOnHandler = () => {
    dispatch({ type: IMPERSONATE.IMPERSONATE_ON });
    dispatch({ type: IMPERSONATE.SET_IMPERSONATE_ID, value: dataItem.subjectId });
    dispatch({ type: IMPERSONATE.SET_IMPERSONATE_NAME, value: dataItem.name });
    setImpersonationToLS(true, dataItem.subjectId, dataItem.name);
    setChecked(true);
    filterCtx.clearAllFilters();
    useForceUpdate();
  };

  const clickOffHandler = () => {
    setChecked(false);
  };

  useEffect(() => {
    impersonate.impersonateId === dataItem.subjectId ? setChecked(true) : setChecked(false);
  }, [impersonate]);

  return (
    <td className='impersonate-select-cell'>
      {checked ? <Icon name='fas fa-circle-dot' onClick={clickOffHandler} /> :
        <Icon name='far fa-circle' onClick={clickOnHandler} />}
    </td>
  );
};

export default SelectCell;